import "../../pages/payment/index.css";
import PaypalPayment from "./payPalPayment";
import Checkout from "./Checkout";
import React from "react";
import usePayment from "./customHook";

export default function Payment() {
  const {
    schema,
    isLoading,
    paymentGateway,
    paymentResponse,
    onSubmit,
    serviceCartArr,
    totalAmount,
    getCountries,
    country,
    state,
    isDevoteeLoggedIn,
    devoteeData,
    handleChildrenRemove,
    increaseQuantity,
    decreaseQuantity,
    city,
    handleCountryChange,
    handleStateChange
  } = usePayment();

  return isLoading && paymentGateway == 2 ? (
    <PaypalPayment orderID={paymentResponse?.payment_session_id} />
  ) : (
    <Checkout
      onSubmit={onSubmit}
      isLoading={isLoading}
      serviceCartArr={serviceCartArr}
      totalAmount={totalAmount}
      schema={schema}
      getCountries={getCountries}
      country={country}
      state={state}
      city={city}
      isDevoteeLoggedIn={isDevoteeLoggedIn}
      devoteeData={devoteeData}
      handleChildrenRemove={handleChildrenRemove}
      increaseQuantity={increaseQuantity}
      decreaseQuantity={decreaseQuantity}
      handleCountryChange={handleCountryChange}
      handleStateChange={handleStateChange}
    />
  );
}
